module.exports = __webpack_public_path__ + "img/icon_foot_close.fd933653.png";